import * as React from 'react';
import { FilespaceExtended, FilespaceStats } from 'fs-api-client';
import { formatDataSize } from '../../../webportal/utils/utilFunctions';
import { BackOfficeEvent } from '../common/BackOfficeEvents';
import { EventManager } from '../../../webportal/services/EventManager';

interface FilespaceDetailsModalProps {
    filespaceStats: FilespaceStats;
    filespace: FilespaceExtended;
    isModalShown: boolean;
    fullFilespaceName: string;
}

interface FilespaceDetailsModalState {

}

export class FilespaceDetailsModal extends React.Component<FilespaceDetailsModalProps, FilespaceDetailsModalState> {
    constructor(props: FilespaceDetailsModalProps) {
        super(props);
        this.state = {
            isModalShown: false
        };
    }

    render() {
        const filespaceStats = this.props.filespaceStats;
        const filespace = this.props.filespace;
        const modalClassName = this.props.isModalShown ? 'modalBO show' : 'modalBO';
        return (
            <div className={modalClassName} id="confirmModal" tabIndex={-1} role="dialog" aria-labelledby="confirmModal" aria-hidden="true">
                <div>
                    <header className="center">
                        <h2>
                            Details for<br/>
                            {this.props.fullFilespaceName}
                        </h2>
                        {filespace.hosts && this.renderFilespaceDigitalOceanLink(filespace.hosts)}
                    </header>
                    <section>
                        {this.renderFilespaceDetails(filespace, filespaceStats)}
                    </section>
                    <footer>
                        <a onClick={this.resetModalState} data-dismiss="modal" className="close" aria-label="close" href="javascript:void(0)">Close</a>
                    </footer>
                </div>
            </div>
        );
    }

    private renderFilespaceDetails(filespace: FilespaceExtended, filespaceStats: FilespaceStats): JSX.Element {
        return (
            <React.Fragment>
                <table className="modalTable" cellPadding="0" cellSpacing="0">
                    {this.renderFilespaceHubInfo(filespace)}
                    {this.renderFilespaceDetailsTableRow('Filespace size', formatDataSize(filespaceStats.filespaceSize))}
                    {this.renderFilespaceDetailsTableRow('Used storage', formatDataSize(filespaceStats.usedStorage))}
                    {this.renderFilespaceDetailsTableRow('Get data size', formatDataSize(filespaceStats.getDataSize))}
                    {this.renderFilespaceDetailsTableRow('Put data size', formatDataSize(filespaceStats.putDataSize))}
                    {this.renderFilespaceDetailsTableRow('Connected devices', filespaceStats.connectedDevices)}
                    {this.renderFilespaceDetailsTableRow('Delete requests count', filespaceStats.deleteRequestCount)}
                    {this.renderFilespaceDetailsTableRow('Get request count', filespaceStats.getRequestCount)}
                    {this.renderFilespaceDetailsTableRow('Put request count', filespaceStats.putRequestCount)}
                    {this.renderFilespaceDetailsTableRow('List request count', filespaceStats.listRequestCount)}
                </table>
            </React.Fragment>
        );
    }

    private renderFilespaceDetailsTableRow(paramName: string, value: any) {
        return (
            <tr>
                <td>{paramName}: </td>
                <td>&nbsp;</td>
                <td className="right">{value}</td>
            </tr>
        );
    }

    private renderFilespaceHubInfo(filespace: FilespaceExtended): JSX.Element {
        return (
            <React.Fragment>
                {this.renderFilespaceDetailsTableRow('Hub region', filespace.hubRegion)}
                {this.renderFilespaceDetailsTableRow('Hub provider', filespace.hubProvider)}
                {this.renderFilespaceDetailsTableRow('Hub backup region', filespace.backupRegion)}
            </React.Fragment>
        );
    }

    private renderFilespaceDigitalOceanLink(filespaceHosts: any []): JSX.Element [] {
        return filespaceHosts.map( (filespaceHost) => {
            const digitalOceanLink = `https://cloud.digitalocean.com/droplets/${filespaceHost.hostId}`;
            return (
                <a key={filespaceHost} href={digitalOceanLink} target="_blank">Hub Droplet</a>
            );
        });
    }

    private resetModalState(): void {
        EventManager.fireCustomEvent(BackOfficeEvent.CloseModal);
        return;
    }
}



// WEBPACK FOOTER //
// ./src/backoffice/components/filespace/FilespaceDetailsModal.tsx